export const USER_TEAMS = "USER_TEAMS"
export const TEAMS_USER_ERROR = "TEAMS_USER_ERROR"
export const TEAMS_USER_SUCCESS = "TEAMS_USER_SUCCESS"

export const APPROVES_TEAMS = "APPROVES_TEAMS"
export const TEAMS_APPROVES_ERROR = "TEAMS_APPROVES_ERROR"
export const TEAMS_APPROVES_SUCCESS = "TEAMS_APPROVES_SUCCESS"

export const REJECTS_TEAMS = "REJECTS_TEAMS"
export const TEAMS_REJECTS_ERROR = "TEAMS_REJECTS_ERROR"
export const TEAMS_REJECTS_SUCCESS = "TEAMS_REJECTS_SUCCESS"

export const WORK_REPORTS = "WORK_REPORTS"
export const WORK_REPORTS_ERROR = "WORK_REPORTS_ERROR"
export const WORK_REPORTS_SUCCESS = "WORK_REPORTS_SUCCESS"
export const SEND_REPORT_FOR_SELECTED_PROJECT = "SEND_REPORT_FOR_SELECTED_PROJECT"

export const EVALUATION_HOURS = "GET_EVALUATION_HOURS"
export const EVALUATION_HOURS_SUCCESS = "EVALUATION_HOURS_SUCCESS"
export const EVALUATION_HOURS_ERROR = "EVALUATION_HOURS_ERROR"

export const REPORT_QUICK_SEND_TO_CLIENT = "POST_REPORT_QUICK_SEND_TO_CLIENT"
export const REPORT_QUICK_SEND_TO_CLIENT_SUCCESS = "REPORT_QUICK_SEND_TO_CLIENT_SUCCESS"
export const REPORT_QUICK_SEND_TO_CLIENT_ERROR = "REPORT_QUICK_SEND_TO_CLIENT_ERROR"

export const HOUR_SUMMARY_REPORT = "POST_HOUR_SUMMARY_REPORT"
export const HOUR_SUMMARY_REPORT_SUCCESS = "HOUR_SUMMARY_REPORT_SUCCESS"
export const HOUR_SUMMARY_REPORT_ERROR = "HOUR_SUMMARY_REPORT_ERROR"

// ** global ** //
export const SET_MODAL = "SET_MODAL"
export const SET_ROW_LIST_DATA = "SET_ROW_LIST_DATA"
export const SET_MOBILE_VIEW = "SET_MOBILE_VIEW"
export const SET_SELECTED_ARRAY_LISTS = "SET_SELECTED_ARRAY_LISTS"
export const SET_SELECTED_REPORT_ITEM = "SET_SELECTED_REPORT_ITEM"
export const SET_SELECTE_TOGGLE = "SET_SELECTE_TOGGLE"
export const SET_TEAM_SCREEN_MODAL ="SET_TEAM_SCREEN_MODAL"
export const SET_ACTIVE_SCREEN_FILTER = "SET_ACTIVE_SCREEN_FILTER"
export const SET_VERIFY_SCREEN = "SET_VERIFY_SCREEN"

export const SET_SUMMARY_DATA_TEAM = "SET_SUMMARY_DATA_TEAM"
export const SET_SUMMARY_MODAL_TEAM = "SET_SUMMARY_MODAL_TEAM"
export const SET_SUMMARY_MODAL = "SET_SUMMARY_MODAL"
export const SET_SUMMARY_DATA = "SET_SUMMARY_DATA"

export const SET_FULL_VIEW_MODAL_TEAM = "SET_FULL_VIEW_MODAL_TEAM"
export const SET_FULL_VIEW_REPORT = "SET_FULL_VIEW_REPORT"
export const SET_SELECTED_HOURS_TEAM = "SET_SELECTED_HOURS_TEAM"

// hours report page get api
export const GET_HOURS_REPORT = "GET_HOURS_REPORT"
export const GET_HOURS_REPORT_SUCCESS = "GET_HOURS_REPORT_SUCCESS"
export const GET_HOURS_REPORT_ERROR = "GET_HOURS_REPORT_ERROR"

export const SET_BOOK_MARKS ="SET_BOOK_MARKS"
export const UPDATE_BOOK_MARKS_LISTS = "UPDATE_BOOK_MARKS_LISTS"
